<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="
            mb-2
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>

          <div class="page-title-right">
            <div class="col text-right" v-if="$can('create', 'users')">
              <router-link :to="{ name: 'CreateUser' }" class="btn btn-primary">
                <b>Nouveau</b>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 pb-4">
        <div class="q-pa-md">
          <div v-if="isLoading" class="mt-2">
            <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
          </div>
          <div class="row" v-else-if="users.length > 0">
            <div class="col-12 col-md-6 d-block d-lg-none"  v-for="user in pageOfItems" :key="user.id">
              <b-card class="border">
                <b-card-title>
                  <img v-if="user.picture != null" :src="load_image(user.picture_small)" alt=""
                        style="border-radius: 50%" width="40" />
                      <img v-else src="@/assets/images/users/default.svg" alt="" style="border-radius: 8px" width="40" />
                      {{ user.firstname + " " + user.lastname }}
                </b-card-title>

                <b-card-text class="small text-muted">{{ user.email }}</b-card-text>

                <b-card-text>
                  <div v-if="user.actif">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" v-model="user.actif" @click="updateStatus(user.id)"
                        class="custom-control-input" :id="user.id" />
                      <label class="custom-control-label" :for="user.id">
                        <span>
                          {{ $t("pages.users.status") }} {{ $t("pages.users.active") }}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" v-model="user.actif" @click="updateStatus(user.id)"
                        class="custom-control-input" :id="user.id" />
                      <label class="custom-control-label" :for="user.id">
                        <span>
                          {{ $t("pages.users.status") }} {{ $t("pages.users.inactive") }}
                        </span>
                      </label>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="col-12 d-none d-lg-table">
              <table class="table table-hover mt-2">
                <thead class="thead-light">
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-left">{{ $t("pages.users.fullname") }}</th>
                    <th class="text-left">{{ $t("pages.users.mail") }}</th>
                    <th class="text-left">{{ $t("pages.users.status") }}</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in pageOfItems" :key="user.id" class="table-row">
                    <td class="text-center">
                      <img v-if="user.picture != null" :src="load_image(user.picture_small)" alt=""
                        style="border-radius: 50%" width="40" />
                      <img v-else src="@/assets/images/users/default.svg" alt="" style="border-radius: 8px" width="40" />
                    </td>
                    <td>{{ user.firstname + " " + user.lastname }}</td>
                    <td>{{ user.email }}</td>
                    <td>
                      <div v-if="user.actif">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" v-model="user.actif" @click="updateStatus(user.id)"
                            class="custom-control-input" :id="user.id" />
                          <label class="custom-control-label" :for="user.id">
                            <span>
                              {{ $t("pages.users.active") }}
                            </span>
                          </label>
                        </div>
                      </div>
                      <div v-else>
                        <div class="custom-control custom-switch">
                          <input type="checkbox" v-model="user.actif" @click="updateStatus(user.id)"
                            class="custom-control-input" :id="user.id" />
                          <label class="custom-control-label" :for="user.id">
                            <span>
                              {{ $t("pages.users.inactive") }}
                            </span>
                          </label>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item @click="
                            $router.push({ path: `/users/show/${user.id}` })
                          ">
                          {{ $t("pages.users.display") }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="
                            $router.push({ path: `/users/edit/${user.id}` })
                          ">
                          {{ $t("pages.users.edit") }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="onDelete(user)">
                          {{ $t("pages.users.delete") }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="text-center empty-state-container" v-else>
            <div class="row">
              <div class="col-md-3 mx-auto">
                <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
              </div>
            </div>
            <h4 class="text-center">{{ $t("pages.users.inactiveUser") }}</h4>
            <p class="mt-2">{{ $t("pages.users.userData") }}</p>
          </div>
          <!-- <div class="empty-state text-center" v-else>
            <i class="bx bxs-file mb-3"></i>
            <h4 class="text-center">{{ $t("pages.users.inactiveUser") }}</h4>
            <p class="mt-2">
              {{ $t("pages.users.userData") }}
            </p>                 
          </div> -->
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination :pageSize="pageSize" :items="users" @changePage="onChangePage" :labels="labels"
                class="text-center"></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Users",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    LottieAnimation
  },
  data() {
    return {
      isLoading: false,
      title: "pages.users.title",
      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 5
    };
  },
  methods: {
    ...mapActions(["getUsers", "updateUserStatus", "deleteUser"]),
    show(userId) {
      this.$router.push({ path: `/users/show/${userId}` });
    },

    edit(userId) {
      this.$router.push({ path: `/users/edit/${userId}` });
    },

    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },

    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
      console.log(" items:" + this.pageOfItems);
    },

    onDelete(user) {
      if (this.$can("delete", "users")) {
        this.$toasted.clear();
        this.$swal({
          text: this.$t("pages.users.swal") + ` ${user.firstname} ?`,
          confirmButtonColor: "#d33",
          confirmButtonText: this.$t("pages.users.delete"),
        }).then((result) => {
          if (result.value) {
            this.deleteUser(user.id)
              .then((response) => {
                if (response) {
                  this.isDeleting = true;
                  this.$swal(
                    this.$t("pages.users.actions.confirm"),
                    this.$t("pages.users.actions.deleted"),
                    "success"
                  ).then(() => {
                    this.isLoading = false;
                  });
                } else {
                  this.isDeleting = false;
                }
              })
              .catch(() => {
                this.$toasted.error(this.$t("pages.users.actions.impossible"));
              });
          }
        });
      } else {
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },

    updateStatus(id) {
      this.updateUserStatus(id)
        .then((response) => {
          if (response.status == 200) {
            this.$toasted.success(this.$t("pages.users.actions.updatedStatus"));
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toasted.error(this.$t("pages.unauthorized.error_0"));
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState({
      // users: (state) => state.user.users,
    }),
    users: function() {
      return this.$store.state.user.users;
    }
  },
  created() {
    this.isLoading = true;
    this.$store.dispatch("getUsers").then(() => {
      // this.users = response.data;
      this.isLoading = false;
    });
    // this.getUsers()
  },
};
</script>

<style lang="scss" scoped>
.table-row {
  cursor: pointer;
  .card-drop {
    visibility: hidden;
  }
  &:hover {
    & .card-drop {
      visibility: visible;
      align-self: center;
    }
  }
}
</style>



